
$(document).ready(function(){

  $('a[data-load-more-target]').each(function(i) {
      let targetSelector = $(this).attr('data-load-more-target')
      let $target = $(this).closest('.lmp').find('#' + targetSelector);

      $(this).click(function(e) {
          e.preventDefault()

          let $this = $(this);
          let thisUrl  = $(this).attr('href')

          if(!$(this).hasClass("load")) {

              $(this).addClass("load")

              Drupal.ajax({
                  url: thisUrl,
                  success: (response) => {
                      let content = response[1] ? response[1].data : response[0].data;

                      let $newElems = $(content).find('#' + targetSelector).children()
                      let $newLink = $(content).find('a[data-load-more-target]');

                      if($newLink.length > 0)
                          $this.attr('href', $newLink.attr('href'))
                      else
                          $this.remove();


                      $target.append($newElems)
                      $target.isotope( 'appended',$newElems);

                      setTimeout(() => $target.isotope( 'layout' ), 500)

                      $(this).removeClass("load")

                      if($newElems.length == 0)
                          $(this).remove()

                  }
              }).execute();
          }
      })
  })
});



// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/load-more.js